import { create } from 'zustand'

interface LoginFormState {
  email: string | null
  password: string | null
  remember_me: boolean
  mfa_code: string
  showPassword: boolean
  loading: boolean
  setLoginForm: (data: Partial<Omit<LoginFormState, 'setLoginForm'>>) => void
  setShowPassword: (show: boolean) => void
  setLoading: (loading: boolean) => void
  resetLoginStore: () => void
}

export const useLoginFormStore = create<LoginFormState>()(set => ({
  email: null,
  password: null,
  remember_me: false,
  mfa_code: '',
  showPassword: false,
  loading: false,
  setLoginForm: data => {
    set(state => ({ ...state, ...data }))
  },
  setShowPassword: show => {
    set({ showPassword: show })
  },
  setLoading: loading => {
    set({ loading })
  },
  resetLoginStore: () => {
    set({
      email: null,
      password: null,
      remember_me: false,
      mfa_code: '',
    })
  },
}))
